import type { ActionRequirement } from '@morpho-org/morpho-sdk'

import type { BuiltTxRequirement } from './TransactionV2.context'

/**
 * Short `sig:<type>` / `tx:<type>` label for a built or signable requirement, used in Sentry
 * breadcrumbs. v6 `getRequirements()` returns `readonly ActionRequirement[]` (a union of call
 * requirements and signature requirements whose members no longer fit `isRequirementSignature`'s
 * narrow parameter), so members are discriminated structurally: a signature requirement exposes
 * `sign()`, a call requirement does not.
 */
export const describeRequirement = (
  requirement: BuiltTxRequirement | ActionRequirement
): string => {
  const type = ('action' in requirement ? requirement.action?.type : undefined) ?? 'unknown'
  return 'sign' in requirement ? `sig:${type}` : `tx:${type}`
}
